import { ApiService } from './api.service';
import { StudentCompetencyComparison, StudentCompetencyData, StudentCompetencyDistribution } from '@/models/student/student-competency-data';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';

class StudentCompetencyDataService extends ApiService {
  constructor() {
    super();
  }

  getStudentCompetencyData(studentID: number = 1): Promise<StudentCompetencyData> {
    return this.get(StudentCompetencyData, `students/${studentID}/competency`, {});
  }

  getStudentCompetencyDistributions(studentID: number, targetType: number, targetID: number): Promise<StudentCompetencyDistribution[]> {
    return this.getList(StudentCompetencyDistribution, `students/${studentID}/competencies`, {
      targetType,
      targetID,
    });
  }

  getStudentCompetencyGrowth(studentID: number): Promise<StudentCompetencyGrowth[]> {
    return this.getList(StudentCompetencyGrowth, `students/${studentID}/competencyGrowth`, {});
  }
}

export const studentCompetencyDataService = new StudentCompetencyDataService();
